import React, { useEffect, useCallback, useState } from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import CurrencyInput from 'components/CurrencyInput';

import TextArea from 'components/TextArea';
import Button from 'components/Button';
import ModalHeader from 'components/ModalHeader';
import api from 'services/api';

import { toast } from 'react-toastify';
import Input from 'components/Input';
import Select from 'components/ReactSelect';
import { Container, Content } from './styles';

interface LastStepProps {
  hour: number;
  minutes: number;
}
interface SelectProps {
  value: string;
  label: string;
}
interface PageProps {
  closeModal: () => void;
}
const schema = yup.object().shape({
  hour: yup.string().required(),
  minutes: yup.string().required(),
});

const AddRuleModal: React.FC<PageProps> = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [percentage, setPercentage] = useState<number>();
  const [selectedOption, setSelectedOption] = useState<SelectProps>();

  const { register, handleSubmit, errors } = useForm<LastStepProps>({
    resolver: yupResolver(schema),
  });

  const optionsSelect = [
    { value: 'true', label: 'Sim' },
    { value: 'false', label: 'Não' },
  ];
  const handleChange = (value: any, action: any) => {
    setSelectedOption(value);
    if (value.value === 'true') {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  };
  const handleChangePorcentagem = () => {
    console.log(percentage);
    // @ts-ignore
    if (percentage > 100) {
      setPercentage(100);
    }
  };

  const onSubmit = useCallback(
    (data: LastStepProps) => {
      try {
        api
          .post('/cancelationRules', {
            hour: data.hour,
            minutes: data.minutes,
            percentage,
            active: isActive,
          })
          .then((response) => {
            toast.success('Regra criada com sucesso!');
            closeModal();
          });
      } catch (error) {
        console.log(error);
      }
    },
    [closeModal, isActive, percentage]
  );
  return (
    <Container>
      <ModalHeader title="Adicionar regra" closeModal={closeModal} />
      <Content>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Input
            title="Hora"
            label="Hora"
            max={100}
            type="number"
            name="hour"
            register={register}
            error={!!errors.hour?.message}
          />
          <Input
            title="Minuto"
            label="Minuto"
            max={100}
            type="number"
            name="minutes"
            register={register}
            error={!!errors.minutes?.message}
          />
          <Input
            title="Porcentagem"
            type="number"
            name="percentage"
            value={percentage}
            max={100}
            onChange={(e) => setPercentage(Number(e.target.value))}
            onKeyDown={handleChangePorcentagem}
          />
          <Select
            className="select"
            label="Ativo"
            options={optionsSelect}
            closeMenuOnSelect
            value={selectedOption}
            onChange={handleChange}
          />
          <Button type="submit">{loading ? 'Entrando...' : 'Salvar'}</Button>
        </form>
      </Content>
    </Container>
  );
};

export default AddRuleModal;
